import { isFeatureEnabled } from '@lumapps/features';

import { FRONTIERS_ALPHA_FF, LUMAPPS_APPLICATION_IDENTITY_FEATURE_TOKEN } from '../constants';

export const isLumappsApplicationIdentityEnabled = isFeatureEnabled(LUMAPPS_APPLICATION_IDENTITY_FEATURE_TOKEN);

export const isFrontiersAlphaEnabled = isFeatureEnabled(FRONTIERS_ALPHA_FF);
